module.exports = __webpack_public_path__ + "static/Banner-about-mobile-09881feb9bca95992425124ea208ad14.png";